// import { resolveBrandCountry } from '../branding/common/utils/resolveBrandCountry';

export const getBrandBoolean = () => {
  // const { brand } = resolveBrandCountry();
  return { isBrandTranqui: true };
};
